import {FC, useState} from 'react';
import {Box, Tabs, Tab, Typography, Divider, Alert} from '@mui/material';
import {MagicCardContentTab} from './MagicCardContentTab';
import {MagicCardMetaTab} from './MagicCardMetaTab';
import type {WordInfo} from '../../types/wordbook';

interface Props {
    word: WordInfo;
}

export const MagicCardExpandedPanel: FC<Props> = ({word}) => {
    const [tab, setTab] = useState(0);

    if (!word.magicCard) {
        return (
            <Box>
                <PanelHeader word={word}/>
                <Alert severity="info" variant="outlined">
                    이 단어에는 매직카드 데이터가 없습니다 (전역 캐시도 유저 상태도 없음).
                </Alert>
            </Box>
        );
    }

    return (
        <Box>
            <PanelHeader word={word}/>
            <Tabs
                value={tab}
                onChange={(_, v) => setTab(v)}
                sx={{minHeight: 36, mb: 1.5}}
            >
                <Tab label="매직카드 내용" sx={{minHeight: 36}}/>
                <Tab label="메타 & 유저 상태" sx={{minHeight: 36}}/>
            </Tabs>
            {tab === 0 && <MagicCardContentTab summaryJson={word.magicCard.cacheSummaryJson}/>}
            {tab === 1 && <MagicCardMetaTab info={word.magicCard}/>}
        </Box>
    );
};

const PanelHeader: FC<{word: WordInfo}> = ({word}) => (
    <Box mb={1.5}>
        <Typography variant="body2">
            <Box component="span" fontWeight={600}>{word.wordText}</Box>
            <Box component="span" color="text.secondary" sx={{ml: 0.5, fontSize: '0.75rem'}}>
                ({word.wordLang})
            </Box>
            <Box component="span" sx={{mx: 1}}>→</Box>
            <Box component="span">{word.meaningText}</Box>
            <Box component="span" color="text.secondary" sx={{ml: 0.5, fontSize: '0.75rem'}}>
                ({word.meaningLang})
            </Box>
        </Typography>
        <Divider sx={{mt: 1}}/>
    </Box>
);
